import type { ContractorAuState } from './contractorStateLabels';

/**
 * Approximate viewport bounds for each AU state/territory. Used with Google Places
 * Autocomplete {@link google.maps.places.AutocompleteOptions.strictBounds} so
 * region search stays within the state row the contractor selected.
 */
export const CONTRACTOR_STATE_PLACES_BOUNDS: Record<
    ContractorAuState,
    google.maps.LatLngBoundsLiteral
> = {
    NSW: { south: -37.65, west: 140.98, north: -28.0, east: 153.69 },
    QLD: { south: -29.2, west: 137.99, north: -9.08, east: 153.65 },
    VIC: { south: -39.2, west: 140.95, north: -33.98, east: 150.05 },
    ACT: { south: -35.95, west: 148.75, north: -35.12, east: 149.45 },
    SA: { south: -38.1, west: 128.9, north: -26.0, east: 141.0 },
    WA: { south: -35.2, west: 112.5, north: -13.5, east: 129.2 },
    NT: { south: -26.5, west: 128.9, north: -11.5, east: 138.1 },
    TAS: { south: -43.75, west: 143.75, north: -39.45, east: 149.15 },
};

export function contractorStatePlacesAutocompleteOptions(
    state: ContractorAuState,
): google.maps.places.AutocompleteOptions {
    return {
        types: ['locality', 'colloquial_area', 'political'],
        fields: [
            'address_components',
            'place_id',
            'formatted_address',
            'geometry',
        ],
        componentRestrictions: { country: 'au' },
        bounds: CONTRACTOR_STATE_PLACES_BOUNDS[state],
        strictBounds: true,
    };
}
